import { render } from "./Resume.vue?vue&type=template&id=a914b198&scoped=true"
const script = {}

import "./Resume.vue?vue&type=style&index=0&id=a914b198&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src748492411/src/personal-webpage-vue-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a914b198"]])

export default __exports__